import React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import 'react-html5-camera-photo/build/css/index.css';
import { ReactComponent as Header } from '../images/header_nuevo.svg';
import { useMinimalSelectStyles } from '../styles/index.js';
import ListaHorarios from './ListaHorarios.js';
import Footer from './Footer.js';
import EnvioAviso from './EnvioAviso.js';
import { ConstraintLayout} from "react-constraint-layout";
import Config from "../config.json"
import { useSnackbar } from 'notistack';

import {isBrowser, isMobile} from "react-device-detect";

const NO_MOSTRAR = 0;
const MOSTRAR = 1;
const SOLO_HIJOS = 2;

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  spinner: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  header: {   
    width: '100%',
    height: '50%'
  },

}));


export default function Formulario(props) {
  const classes = useStyles();
  const [municipio, setMunicipio] = React.useState('none');
  const [nombreMunicipio, setNombreMunicipio] = React.useState('');
  const [mostrarPoblacion, setMostrarPoblacion] = React.useState(false);
  const [poblacion, setPoblacion] = React.useState('none');
  const [tipo, setTipo] = React.useState('none');
  const [position, setPosition] = React.useState();
  const [dialogIntro, setDialogIntro] = React.useState(false);
  const [estado, setEstado] = React.useState('hide');
  const [horarios, setHorarios] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');;
  const minimalSelectClasses = useMinimalSelectStyles();
  const { enqueueSnackbar } = useSnackbar();


  const handleCloseIntro = () => {
    setDialogIntro(false);
    localizar()
  };

  function localizar(){
    if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(onSucccess, onError, config );  
    } else {
      alert('not supported');
    } 
  }

  function onSucccess(position) {
    //console.log(position.coords.latitude, position.coords.longitude);    
    setPosition(position)  
  }

    
  /*se ejecuta si el permiso fue denegado o no se puede encontrar una ubicación*/
  function onError(error) { 
    enqueueSnackbar('Se produjo un error obteniendo la ubicación.',{variant: 'error'});
  }
  
  var config = {
    enableHighAccuracy: true, 
    maximumAge        : 30000, 
    timeout           : 27000
  };

  React.useEffect(() => {  
    /*navigator.permissions.query({name:'geolocation'}).then(function(result) {     
      if (result.state !== 'granted')
        setDialogIntro(true);
      else
        localizar()
    }) */
    setDialogIntro(true);  
}, []);

    function scrollBottom(){
      window.scrollTo(0,document.body.scrollHeight);
    }


    function clearState(){
      setTipo('none')      
      setEstado('hide')
      setHorarios('')          
    }

    const handleChangeMunicipio = (event) => {
      setMunicipio(event.target.value);
      var municipio = Config.poblaciones.filter(pob => (pob.COD === event.target.value))[0]  
      var poblaciones = Config.poblaciones.filter(pob => (pob.Municipio === municipio.Municipio && pob.visible !== NO_MOSTRAR))  
      setNombreMunicipio(municipio.Municipio) 
      if(poblaciones.length===1){       
        setPoblacion(municipio.COD)
        setMostrarPoblacion(false)
        if(tipo!=='none')
        getHorarios(tipo,event.target.value);   
      }   
      else{      
        setMostrarPoblacion(true)
        setPoblacion('none')
        setTipo('none')
        setEstado('hide')
        setHorarios('')    
      }  
    } 

    const handleChangePoblacion = (event) => {
      setPoblacion(event.target.value);   
      if(tipo!=='none')
        getHorarios(tipo,event.target.value);     
    }  

  const handleChange = (event) => {
    setTipo(event.target.value);  
    if(poblacion!=='none' || isMobile)
      getHorarios(event.target.value,poblacion);
  }  


function getHorarios(tipo, poblacion){
  var url;  
    if(isMobile){
      url = Config.SERVER_URL +'getDireccion/' + tipo +"/" + position.coords.latitude + "/" +position.coords.longitude    
      // = Config.SERVER_URL +'getDireccion/' + tipo +"/" + 37.259239 + "/" + -6.940887    
    }
    else{
      url = Config.SERVER_URL +'getHorarios/' + tipo +"/" + poblacion  
    }
    setEstado('loading');
    fetch(url)
      .then(response => response.json())
      .then(function(data) {      
        setTimeout(() => {
          if(data.errorMessage === null){          
            setHorarios(data)  
            setEstado('OK')          
            scrollBottom()       
          }
          else{
            setEstado('ERROR')
            setErrorMessage(data.errorMessage) 
            setHorarios(null)
          }      
        }, 500);       
       
     })
     .catch(function(){  
        setTimeout(() => {
          setEstado('ERROR')
          setErrorMessage('Se produjo un error inesperado') 
          setHorarios(null)  
        }, 500);       
       })
}

  const iconComponent = (props) => {
      return (
        <ExpandMoreIcon className={props.className + " " + minimalSelectClasses.icon}/>
      )};

        
  // moves the menu below the select input
  const menuProps = {
      classes: {
        paper: minimalSelectClasses.paper,
        list: minimalSelectClasses.list
      },
      anchorOrigin: {
        vertical: "top",
          horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
          horizontal: "left"
      },
      getContentAnchorEl: null
    };


    return (
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <div className={classes.paper}>
        {isMobile &&  <DialogInicio/>   }      
          <ConstraintLayout width="100%" >
            {isMobile &&
            <Header        
              id="header"     
              leftToLeftOf="_parent"
              rightToRightOf="_parent"
              topToTopOf="_parent"  
              width="match-parent" 
              height="250px"
            /> }
            {isBrowser &&
            <div
              id="municipio"     
              leftToLeftOf="_parent"
              rightToRightOf="_parent"
              topToTopOf="header"         
              marginTop="8px"
              width="match-parent" 
              height="70px">
              <FormControl className={classes.spinner}>   
                <Select                  
                    disableUnderline
                    classes={{ root: minimalSelectClasses.select }}
                    MenuProps={menuProps}
                    IconComponent={iconComponent}
                    value={municipio}
                    onChange={handleChangeMunicipio}>
                  <MenuItem key="none" value="none" disabled>Seleccione un municipio</MenuItem>              
                  {Config.poblaciones.filter(pob => (pob.Municipio === pob.poblacion && pob.visible !== NO_MOSTRAR))
                  .map(value => (
                       <MenuItem key={value.COD} value={value.COD}>{value.Municipio}</MenuItem>  
                 ))}
                </Select>
              </FormControl>
            </div>}
            {(municipio !=='none' && mostrarPoblacion) &&
            <div
              id="poblacion"
              leftToLeftOf="_parent"
              rightToRightOf="_parent"
              topToBottomOf="municipio"
              sm_topToBottomOf="municipio" 
              md_topToBottomOf="municipio" 
              lg_topToBottomOf="municipio" 
              xl_topToBottomOf="municipio" 
              marginTop="8px"
              width="match-parent" 
              height="70px">
              <FormControl className={classes.spinner}>   
                <Select                  
                    disableUnderline
                    classes={{ root: minimalSelectClasses.select }}
                    MenuProps={menuProps}
                    IconComponent={iconComponent}
                    value={poblacion}
                    onChange={handleChangePoblacion}>
                       <MenuItem key="none" value="none" disabled>Seleccione una poblacion</MenuItem>      
                    {  Config.poblaciones.filter(pob => (pob.Municipio === nombreMunicipio && pob.visible === MOSTRAR)).map(value => (
                       <MenuItem key={value.COD} value={value.COD}>{value.poblacion}</MenuItem>  
                 ))}
                </Select>
              </FormControl>
            </div>}
            {(poblacion !=='none' || isMobile) &&
            <div
              leftToLeftOf="_parent"
              rightToRightOf="_parent"
              topToBottomOf={isMobile?"header":mostrarPoblacion?"poblacion":"municipio"}
              marginTop="8px"
              width="match-parent" 
              height="70px">
              <FormControl className={classes.spinner}>   
                <Select                  
                    disableUnderline
                    classes={{ root: minimalSelectClasses.select }}
                    MenuProps={menuProps}
                    IconComponent={iconComponent}
                    value={tipo}
                    onChange={handleChange}>
                  <MenuItem value="none" disabled>Seleccione un tipo de residuo</MenuItem>              
                  <MenuItem value={"M"}>Muebles y enseres</MenuItem>      
                  <MenuItem value={"P"}>Restos de poda</MenuItem>    
                </Select>
              </FormControl>
            </div>}
            </ConstraintLayout>              
            <ExistenHorarios {...props}/>    
            {isMobile &&        
              <Footer/>}
      
        </div>
      </Container>
    );

    function DialogInicio(){
      return(
        <Dialog
        open={dialogIntro}
        onClose={handleCloseIntro}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Campaña municipios cinco estrellas"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bienvenido al programa de recogida de muebles, enseres, electrodomésticos y poda de Giahsa.
            Es importante que acepte los permisos de ubicación para poder saber en que localidad se encuentra y gestionar su solicitud.
          </DialogContentText>
        </DialogContent>
        <DialogActions>        
          <Button onClick={handleCloseIntro} color="primary" >
            <b>Entendido</b>
          </Button>
        </DialogActions>
      </Dialog>
      )
    }
    
    function MostrarHorarios(props) {  
      return (
      <div className = {classes.spinner}>
        <ListaHorarios estado={estado} horarios={horarios} error={errorMessage}/>
        {estado==='OK' &&<EnvioAviso {...props} 
        ayuntamientos={props.ayuntamientos}
        horarios={horarios}
        position={position}
        tipo={tipo}
        clear={() => clearState()}/> }     
      </div>
    )}  
  
    function ExistenHorarios(props) {       
      if (estado!=='hide') {
        return <MostrarHorarios {...props}/>;
      }
      else{
        return null;
      }
    
    }
 
}